import { Pricing } from './ProductCatalog';
import './styles/PromoCountdown.scss';

// The global promo deadline echoed on every discounted product (see backend
// ProductPricingResponseModel.DiscountValidUntil). All discounted products carry the
// same date, so the first one that has it is the single site-wide countdown.
export function promoDeadline(pricing: Pricing[]): string | null {
    return pricing.find((p) => p.discountValidUntil)?.discountValidUntil ?? null;
}

// Czech plural for "den": 1 → den, 2–4 → dny, 0 & 5+ → dní.
function dayWord(days: number) {
    if (days === 1) return "den";
    if (days >= 2 && days <= 4) return "dny";
    return "dní";
}

// Days-remaining urgency badge shown while the launch price is still live. The
// deadline is the last day the price is valid (backend charges the anchor from the
// next day), so we count to the end of that calendar day. Renders nothing once the
// window has closed — the backend already reverts the price to the anchor by then.
export default function PromoCountdown({ deadline, className }: { deadline?: string | null; className?: string }) {
    if (!deadline) return null;

    const end = new Date(deadline);
    if (isNaN(end.getTime())) return null;
    end.setHours(23, 59, 59, 999);

    const ms = end.getTime() - Date.now();
    if (ms <= 0) return null;

    const days = Math.ceil(ms / 86400000);

    return (
        <span className={"promoCountdown" + (className ? " " + className : "")}>
            <span className="pulse" />
            {days === 1
                ? <span>Poslední den <strong>zvýhodněné ceny</strong></span>
                : <span>Zvýhodněná cena končí za <strong>{days} {dayWord(days)}</strong></span>}
        </span>
    );
}
